import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">漫画分类</h2>
            <p className="text-foreground-500 text-sm max-w-md">按喜好筛选，找到属于你的那本漫画</p>
          </div>
          <Link to="/category/romance" className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
            查看全部分类 →
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.slice(0, 9).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-start justify-between mb-3">
                <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                  <i className={`${cat.icon} text-accent-600 text-xl`}></i>
                </div>
                <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full">{cat.count}部</span>
              </div>
              <h3 className="text-foreground-900 font-medium text-sm md:text-base mb-1">{cat.name}</h3>
              <p className="text-foreground-500 text-xs">共 {cat.count} 部作品</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}